module.exports = __webpack_public_path__ + "img/badge-chimiotherapie-02.66482f94.png";